var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject4ModalShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643_15925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1019 24.9267C53.73 32.0251 51.0175 38.2704 46.4347 43.6954C43.5472 47.1189 39.9488 49.6345 36.0878 51.822C33.9332 53.036 31.8222 54.3157 29.7003 55.5954C28.8144 56.1204 27.9832 56.1423 27.0972 55.6064C24.1441 53.8454 21.1472 52.1501 18.216 50.3345C9.01753 44.6251 3.86597 36.3345 2.66285 25.6048C2.52066 24.3689 2.5316 23.111 2.50972 21.8642C2.48785 20.6173 2.50972 19.3704 2.50972 18.1235C2.50972 15.7829 2.50972 13.4314 2.50972 11.0907C2.50972 9.48292 3.33003 8.70636 4.92691 8.62979C12.6925 8.23604 19.8347 5.98292 26.1238 1.27979C26.43 1.05011 26.7035 0.765731 26.9988 0.525106C27.8738 -0.174894 28.9128 -0.174894 29.7769 0.536043C35.2675 5.05323 41.666 7.42667 48.655 8.37823C49.7816 8.53135 50.93 8.5751 52.0675 8.64073C53.3691 8.71729 54.255 9.54854 54.255 10.861C54.2332 15.5532 54.3535 20.2454 54.1019 24.9267Z",
    fill: "#CDCED7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9488 20.9701C38.5067 21.5533 38.5067 22.4988 37.9488 23.082L26.5202 35.0287C25.9623 35.6118 25.0578 35.6118 24.4999 35.0287L18.7856 29.0553C18.2277 28.4721 18.2277 27.5266 18.7856 26.9434C19.3435 26.3603 20.248 26.3603 20.8059 26.9434L25.51 31.8608L35.9285 20.9701C36.4864 20.3869 37.3909 20.3869 37.9488 20.9701Z",
    fill: "#19191B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643_15925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 55.9974,
    fill: "white",
    transform: "translate(0.5 0.00146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject4ModalShield);
export default __webpack_public_path__ + "static/media/project4_modal_shield.9fe1e48de2a3228c6ebb8d91c4764806.svg";
export { ForwardRef as ReactComponent };